import React, {useContext, useEffect, useState} from 'react';
import {useParams} from "react-router-dom";
import {makeStyles} from "@material-ui/core/styles";
import Avatar from '@material-ui/core/Avatar'
import GetAppIcon from '@material-ui/icons/GetApp';
import HighlightOff from '@material-ui/icons/HighlightOff';
import PropTypes from "prop-types";
import moment from 'moment';
import fileDownload  from 'js-file-download';

import apiFetch, { getBinary } from '../utils/apiUtils';
import { ErrorContext, PermissionsContext } from '../utils/constants';
import updateImageData, {getUserLetter} from "../utils/avatarUtils";

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
  },
  fullWidth: {
    width: '100%',
  },
  avatar: {
    margin: '1rem'
  },
  textDiv: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  nameDiv: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: '1rem'
  },
  name: {
    fontWeight: '700'
  },
  timeSpan: {
    display: 'flex',
    justifyContent: 'flex-end',
    flexGrow: 1,
    fontSize: '12px',
    paddingRight: '0.5rem'
  },
  downloadDivContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  downloadDiv: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
  hr: {
    height: '2px',
    backgroundColor: '#e0e0e0',
    border: 'none'
  }
}));

export default function CommentCard({ comment, onDelete }) {
  const classes = useStyles();
  const [blobUrl, setBlobUrl] = useState(null);
  const params = useParams();
  const { triggerError } = useContext(ErrorContext);
  const { isAdmin } = useContext(PermissionsContext);

  useEffect(() => {
    if (comment) {
      updateImageData(comment, setBlobUrl);
    }
  }, [comment]);

  const getCommentDate = () => {
    const date = new Date(comment.creation_date);
    return moment(date).format("DD MMM YYYY LT");
  };

  const handleAttachmentDelete = (e, comment) => {
    e && e.preventDefault();

    apiFetch(`/downloads/${params.id}/files/${comment.id}`, 'DELETE', '', () => {
        onDelete && onDelete()
      }, () => triggerError({
        title: 'Deletion Error',
        description: `We were unable to delete the attachment. Please try again.`
      }));
  }

  const getAttachmentHref = (comment, filename) => {
    return window.location.origin +  '/downloads/' + params.id + '/files/' + filename;
  };

  const handleAttachmentDownload = (e, comment) => {
    e && e.preventDefault();

    getBinary(`/downloads/${params.id}/files/${comment.id}`, 'GET', '', (fileContent) => {
      fileDownload(fileContent, comment.filename);
    }, () => triggerError({
      title: 'Attachment Download Error',
      description: `We were unable to download the attachment. Please try again.`
    }));
  }

  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return 'Imported';

    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)) + ' ' + sizes[i];
  }

  return (
    <div className={classes.fullWidth}>
      <div className={classes.root} >
        <Avatar alt={comment.name} className={classes.avatar} src={blobUrl}>
          {getUserLetter({name: comment.user_name})}
        </Avatar>
        <div className={classes.textDiv}>
          <div className={classes.nameDiv}>
            <span className={classes.name}>{comment.user_name}</span> <span className={classes.timeSpan}>{getCommentDate()}</span>
          </div>
          {comment.comment? comment.comment : ''}
          {
            comment.comment? '' :
              <div className={classes.downloadDivContainer}>
                <div className={classes.downloadDiv}>
                  <a href={getAttachmentHref(comment, comment.filename)} onClick={(e) => handleAttachmentDownload(e, comment)}><GetAppIcon /></a>
                  {  `Uploaded file '${comment.filename}' with size ${formatBytes(comment.size)}.` }
                </div>
                { isAdmin? <a href='#' onClick={(e) => handleAttachmentDelete(e, comment)}><HighlightOff /></a> : null }
              </div>
          }
        </div>
      </div>
      <hr className={classes.hr}/>
    </div>
  );
}

CommentCard.propTypes = {
  comment: PropTypes.object.isRequired,
  onDelete: PropTypes.func
};
